/* =============================================================================
   NEOMACHI - POLISH LAYER (behaviour)
   1. Product card swipe pager state on touch
   2. PDP model shot under the gallery, kept in sync with the visible gallery media
   3. Phone sticky add-to-cart: visible whenever the main button is off screen
   ============================================================================= */
(function () {
  'use strict';

  /* Keep the Second image on hover app off the WORN THE MOST lifestyle tiles only. */
  window.setAsAppendedOverride = function (args) {
    var object = args && args[1];
    var node = object && object.jquery ? object[0] : object;
    if (node && node.closest && node.closest('.nm-bstiles')) return;
    if (typeof setAsAppended === 'function') setAsAppended(args);
  };

  /* ---------------------------------------------------------------------------
     1. Card swiper pager
     CSS does the scrolling; this only lights the correct bar.
     --------------------------------------------------------------------------- */
  function bindCardSwipers(root) {
    (root || document).querySelectorAll('[data-nm-card-swiper]').forEach(function (media) {
      if (media.dataset.nmBound === '1') return;
      media.dataset.nmBound = '1';

      var card = media.closest('.nm-card');
      var pager = card && card.querySelector('.nm-card__pager');
      if (!pager) return;
      var bars = pager.querySelectorAll('span');
      var ticking = false;

      media.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = media.clientWidth || 1;
          var index = Math.round(media.scrollLeft / w);
          for (var i = 0; i < bars.length; i++) {
            bars[i].classList.toggle('is-active', i === index);
          }
        });
      }, { passive: true });
    });
  }

  /* ---------------------------------------------------------------------------
     2. PDP model shot
     The markup is rendered server-side by snippets/product-gallery.liquid so it
     paints immediately. This keeps it correct after a colour change, by mirroring
     whichever gallery slide is currently second and visible.
     --------------------------------------------------------------------------- */
  function syncModelShot() {
    var shot = document.querySelector('[data-nm-modelshot]');
    if (!shot) return;

    var gallery = document.querySelector('product-gallery');
    if (!gallery) return;

    var slides = Array.prototype.filter.call(
      gallery.querySelectorAll('.product-gallery__media'),
      function (el) {
        if (el.hasAttribute('hidden')) return false;
        if (el.getAttribute('data-media-type') !== 'image') return false;
        return !!el.querySelector('img');
      }
    );

    if (slides.length < 2) {
      shot.hidden = true;
      return;
    }

    var source = slides[1].querySelector('img');
    var target = shot.querySelector('img');
    if (!source || !target) return;

    var srcset = source.getAttribute('srcset') || '';
    var src = source.currentSrc || source.getAttribute('src') || '';
    if (!src && !srcset) return;

    if (target.getAttribute('data-nm-src') === src + '|' + srcset) return;
    target.setAttribute('data-nm-src', src + '|' + srcset);

    /* The shot is shown uncropped at the full width of the gallery column, so it
       needs the same sizes hint as the main image. Without it the browser keeps
       picking a source sized for the old 300px-tall crop and it renders soft. */
    var sizes = source.getAttribute('sizes');
    if (sizes) target.setAttribute('sizes', sizes);

    if (srcset) target.setAttribute('srcset', srcset);
    if (src) target.setAttribute('src', src);
    target.setAttribute('alt', source.getAttribute('alt') || '');
    shot.hidden = false;
  }

  /* ---------------------------------------------------------------------------
     3. Phone sticky add-to-cart (Oct 2026)
     The theme only shows its sticky bar after the shopper has scrolled PAST the
     product form, and the form also wraps the fit panel and specs, so on a phone
     the bar almost never appeared. Clarity recordings showed shoppers scrolling
     back up through the photos with no button in reach. On phones the bar is now
     shown whenever the real add-to-cart button is off screen, above or below,
     once the shopper has started scrolling, and hidden near the footer.
     A tap without a size goes through nm-size-guard, which scrolls to the sizes.
     --------------------------------------------------------------------------- */
  var phoneQuery = window.matchMedia ? window.matchMedia('(max-width: 999px)') : null;
  var stickyTicking = false;

  (function addStickyStyles() {
    if (document.getElementById('nm-sticky-atc-css')) return;
    var style = document.createElement('style');
    style.id = 'nm-sticky-atc-css';
    style.textContent =
      '@media screen and (max-width: 999px) {' +
      '.product-sticky-bar.nm-sticky-on { opacity: 1 !important; visibility: visible !important; }' +
      '.product-sticky-bar.nm-sticky-off { opacity: 0 !important; visibility: hidden !important; }' +
      '.product-sticky-bar { padding: 10px 16px calc(10px + env(safe-area-inset-bottom)) !important; }' +
      '}';
    (document.head || document.documentElement).appendChild(style);
  })();

  function updateStickyBar() {
    stickyTicking = false;
    var bar = document.querySelector('product-sticky-bar');
    if (!bar) return;
    if (!phoneQuery || !phoneQuery.matches) {
      bar.classList.remove('nm-sticky-on', 'nm-sticky-off');
      return;
    }
    var form = document.forms[bar.getAttribute('form')];
    var button = form && form.querySelector('buy-buttons');
    if (!button) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var r = button.getBoundingClientRect();
    var buttonOnScreen = r.bottom > 0 && r.top < vh;
    var footer = document.querySelector('.shopify-section--footer');
    var footerOnScreen = footer ? footer.getBoundingClientRect().top < vh : false;
    var show = !buttonOnScreen && !footerOnScreen && window.scrollY > 150;
    bar.classList.toggle('nm-sticky-on', show);
    bar.classList.toggle('nm-sticky-off', !show);
  }

  function queueStickyBar() {
    if (stickyTicking) return;
    stickyTicking = true;
    requestAnimationFrame(updateStickyBar);
  }

  window.addEventListener('scroll', queueStickyBar, { passive: true });
  window.addEventListener('resize', queueStickyBar);
  document.addEventListener('variant:change', queueStickyBar);

  function init() {
    bindCardSwipers(document);
    syncModelShot();
    updateStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Sections re-render on variant change, filtering and section reloads in the editor. */
  var queued = false;
  var observer = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      bindCardSwipers(document);
      syncModelShot();
    });
  });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'src', 'srcset'] });
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:change', syncModelShot);
})();
